const apiMap: { [key: string]: string } = {
  // 方便独立调试TRTC
  apiGetUsersig: 'https://xiaowei.cloud.tencent.com/vmapi/web/trtc/usersig',
};
export default apiMap;
